import { render, staticRenderFns } from "./config-list-org.vue?vue&type=template&id=1b8c5b65&scoped=true&"
import script from "./config-list-org.vue?vue&type=script&lang=js&"
export * from "./config-list-org.vue?vue&type=script&lang=js&"
import style0 from "./config-list-org.vue?vue&type=style&index=0&id=1b8c5b65&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8c5b65",
  null
  
)

export default component.exports